import React, { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Redirect, useParams, Link } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import { useFormatMessage } from 'hooks';

import CountryForm from 'components/CountryForm';
import paths from 'pages/Router/paths';
import {
  createCountry,
  modifyCountry,
  fetchCountries,
  countriesCleanUp,
} from 'state/actions/countries';

const Country = () => {
  const { id } = useParams();
  const isEditing = !!id;

  const { success, countriesList, error, loading } = useSelector(
    (state) => ({
      success: state.countries.success,
      countriesList: state.countries.data,
      error: state.countries.error,
      loading: state.countries.loading,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  // Extract all useFormatMessage calls at top level
  const editCountryTitle = useFormatMessage('Country.editCountry');
  const newCountryTitle = useFormatMessage('Country.newCountry');
  const goBackLabel = useFormatMessage('Country.goBack');

  useEffect(() => {
    if (isEditing) {
      const countryData = countriesList.find((country) => country.id === id);
      if (!countryData) {
        dispatch(fetchCountries(id));
      }
    }
    return () => {
      dispatch(countriesCleanUp());
    };
  }, [isEditing, id, dispatch]);

  const countryData = countriesList.find((country) => country.id === id) || {
    name: '',
    locale: '',
  };

  const onSubmitHandler = (data) => {
    if (isEditing) {
      dispatch(modifyCountry({ ...data, id }));
    } else {
      dispatch(createCountry(data));
    }
  };

  const redirect = success && <Redirect to={paths.COUNTRIES} />;

  return (
    <>
      {redirect}
      <section className="hero is-hero-bar">
        <div className="hero-body">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <h1 className="title">
                  {isEditing ? editCountryTitle : newCountryTitle}
                </h1>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <Link to={paths.COUNTRIES} className="button">
                  {goBackLabel}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section is-main-section">
        {error && (
          <article className="message is-danger">
            <div className="message-body">{error}</div>
          </article>
        )}
        {loading ? (
          <ClipLoader />
        ) : (
          <div className="tile is-ancestor">
            <div className="tile is-parent">
              <div className="card tile is-child">
                <div className="card-content">
                  <CountryForm
                    country={countryData}
                    onSubmitHandler={onSubmitHandler}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Country;
